import { useMemo } from 'react';
import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.project.$urlSegment._index';
import { useEnquiryModal } from '~/modules/enquiry/hooks/use-enquiry-modal';

/** Label for the project "Book a Meeting" CTA / enquiry-modal title. */
export const BOOK_A_MEETING = 'Book a Meeting';

/**
 * The project enquiry modal, preconfigured with the project + professional
 * context. Shared by the summary "Book a Meeting" CTA and the (03) accordion
 * row, which both fall back to this modal when no bookable session exists. The
 * modal is backed by global atoms, so calling this from more than one component
 * drives the same single modal.
 */
export const useProjectEnquiryModal = () => {
    const { project } = useLoaderData<typeof loader>();

    // Memoised so the returned `openEnquiryModal` keeps a stable identity across
    // renders — island modes depend on it, and an unstable config would churn the
    // controller (re-registering every section each render).
    const data = useMemo(
        () => ({
            professional: project.Professional,
            itemType: 'project' as const,
            siteTreeID: project.ID,
            relatedItem: {
                id: project.ID,
                type: 'project' as const,
                title: project.Title,
                category: project.categoryPath,
            },
        }),
        [project],
    );

    return useEnquiryModal(data);
};
